import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSettings } from '../context/SettingsContext';

export default function Login() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { t, theme, toggleTheme, lang, setLang } = useSettings();
  const navigate = useNavigate();

  const handle = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.username, form.password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg)',
      backgroundImage: 'radial-gradient(ellipse 80% 40% at 50% -10%, rgba(231,107,0,0.12) 0%, transparent 70%)',
      transition: 'background 0.25s',
    }}>

      {/* Top-right: lang + theme toggles */}
      <div style={{ position: 'fixed', top: 20, right: 24, display: 'flex', gap: 10, zIndex: 10 }}>
        <div className="toggle-pill">
          {[['en','EN'], ['ru','RU'], ['uz','UZ']].map(([code, label]) => (
            <button key={code} className={lang === code ? 'active' : ''} onClick={() => setLang(code)}>{label}</button>
          ))}
        </div>
        <div className="toggle-pill">
          <button className={theme === 'dark' ? 'active' : ''} onClick={() => theme !== 'dark' && toggleTheme()}>🌙</button>
          <button className={theme === 'light' ? 'active' : ''} onClick={() => theme !== 'light' && toggleTheme()}>☀️</button>
        </div>
      </div>

      <div style={{ width: '100%', maxWidth: 420, padding: '0 20px' }}>

        {/* Logo — big, centered, no text */}
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <img
            src="/logo.png"
            alt="Inone"
            style={{
              height: 72,
              width: 'auto',
              objectFit: 'contain',
              filter: theme === 'dark' ? 'brightness(1)' : 'brightness(0.92)',
            }}
          />
          <p style={{ color: 'var(--text-muted)', fontSize: 13, marginTop: 14, letterSpacing: '0.01em' }}>
            {t('adminPortal')}
          </p>
        </div>

        {/* Login card */}
        <div className="card" style={{ boxShadow: 'var(--shadow)' }}>
          <form onSubmit={handle}>
            <div className="form-group">
              <label className="form-label">{t('username')}</label>
              <input
                type="text"
                placeholder="admin"
                value={form.username}
                autoFocus
                onChange={e => setForm({ ...form, username: e.target.value })}
              />
            </div>
            <div className="form-group" style={{ marginBottom: 24 }}>
              <label className="form-label">{t('password')}</label>
              <input
                type="password"
                placeholder="••••••••"
                value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })}
              />
            </div>

            {error && (
              <div style={{
                background: 'var(--red-bg)', border: '1px solid rgba(224,92,92,0.2)',
                color: 'var(--red)', borderRadius: 'var(--radius-sm)',
                padding: '10px 14px', fontSize: 13, marginBottom: 16,
              }}>
                {error}
              </div>
            )}

            <button
              type="submit"
              className="btn-primary"
              style={{ width: '100%', padding: '13px', fontSize: 15, letterSpacing: '0.02em' }}
              disabled={loading}
            >
              {loading ? t('signingIn') : t('signIn')}
            </button>
          </form>
        </div>

        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 12, color: 'var(--text-dim)', lineHeight: 1.6 }}>
          {t('setupHint')}
        </p>
      </div>
    </div>
  );
}
